import React from 'react';
import PropTypes from 'prop-types';
import Feedback from '../Feedback';
import ProjectFeedback from '../ProjectFeedback';
import './Feedbacks.scss';

function Feedbacks({
  canCreateFeedback,
  feedbacks,
  handleUpdateFeedback,
  csrfToken,
  emailShareUrl,
  resource,
  resourceId,
  email,
}) {
  if (resource === 'proposal') {
    return (
      <div className="feedbacks">
        { feedbacks.map((feedback) => (
          <Feedback
            canCreateFeedback={canCreateFeedback}
            key={feedback.email}
            csrfToken={csrfToken}
            emailShareUrl={emailShareUrl}
            resource={resource}
            resourceId={resourceId}
            feedback={feedback}
          />
        ))}
      </div>
    );
  }
  let previousEmail;
  let currentEmail;
  return (
    <div className="project-feedbacks feedbacks">
      {feedbacks.map((feedback) => {
        previousEmail = currentEmail;
        currentEmail = feedback.email;
        return (
          <div key={`${feedback.email}-${feedback.id}`} className="grouped-feedbacks">
            <ProjectFeedback
              key={feedback.id}
              canEdit={canCreateFeedback && email === feedback.email && feedback.most_recent}
              displayName={previousEmail !== currentEmail}
              csrfToken={csrfToken}
              emailShareUrl={emailShareUrl}
              resource={resource}
              resourceId={resourceId}
              feedback={feedback}
              note={feedback.note}
              handleUpdateFeedback={(fb, note) => handleUpdateFeedback(fb, note)}
              email={email}
            />
          </div>
        );
      })}
    </div>
  );
}

Feedbacks.propTypes = {
  canCreateFeedback: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  emailShareUrl: PropTypes.string,
  handleUpdateFeedback: PropTypes.func,
  email: PropTypes.string,
};

Feedbacks.defaultProps = {
  canCreateFeedback: false,
  handleUpdateFeedback: () => {},
  email: '',
  emailShareUrl: null,
};

export default Feedbacks;
